import React, { FunctionComponent } from 'react';
import { Status } from '../../status';
import { ErrorCommon } from '../error-common/error-common.component';
export const FourHundred: FunctionComponent = () => (
	<Status code={400}>
		<ErrorCommon />
	</Status>
);
